//ALERT
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

//AUTHENTICATION
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const GUEST_LOADED = 'GUEST_LOADED';
export const ADMIN_LOADED = 'ADMIN_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_USER = 'CLEAR_USER';

//GUEST
export const GET_GUESTS = 'GET_GUESTS';
export const GUEST_ERROR = 'GUEST_ERROR';

//ROOM
export const ADD_ROOM = 'ADD_ROOM';
export const GET_ROOMS = 'GET_ROOMS';
export const GET_MY_ROOM = 'GET_MY_ROOM';
export const UPDATE_ROOM = 'UPDATE_ROOM';
export const DELETE_ROOM = 'DELETE_ROOM';
export const ROOM_ERROR = 'ROOM_ERROR';

//BOOKING
export const ADD_BOOKING = 'ADD_BOOKING';
export const GET_BOOKINGS = 'GET_BOOKINGS';
export const GET_MY_BOOKING = 'GET_MY_BOOKING';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const BOOKING_ERROR = 'BOOKING_ERROR';
export const CANCEL_BOOKING = 'CANCEL_BOOKING';

//COUPON
export const ADD_COUPON = 'ADD_COUPON';
export const GET_COUPONS = 'GET_COUPONS';
export const DELETE_COUPON = 'DELETE_COUPON';
export const COUPON_ERROR = 'COUPON_ERROR';

//PAYMENT
export const GET_KEY = 'GET_KEY';
export const CHECKOUT = 'CHECKOUT';
export const RECEIPT = 'RECEIPT';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const LOAD_RECEIPTS = 'LOAD_RECEIPTS';
export const GET_PAYMENTS = 'GET_PAYMENTS';

//GALLERY
export const LOAD_GALLERY = 'LOAD_GALLERY';
export const GALLERY_ERROR = 'GALLERY_ERROR';
export const ADD_IMAGE = 'ADD_IMAGE';
export const DELETE_IMAGE = 'DELETE_IMAGE';

//FEEDBACK
export const LOAD_FEEDBACK = 'LOAD_FEEDBACK';
export const FEEDBACK_ERROR = 'FEEDBACK_ERROR';
export const ADD_FEEDBACK = 'ADD_FEEDBACK';

//BAR
export const LOAD_BAR = 'LOAD_BAR';
export const BAR_ERROR = 'BAR_ERROR';
export const ADD_BAR = 'ADD_BAR';
export const BOOK_BAR = 'BOOK_BAR';
export const BAR_BOOKINGS = 'BAR_BOOKINGS';
export const MY_BAR_BOOKINGS = 'MY_BAR_BOOKINGS';
export const DELETE_BAR_BOOKING = 'DELETE_BAR_BOOKING';
export const CANCEL_BAR_BOOKING = 'CANCEL_BAR_BOOKING';

//CONFERENCE
export const LOAD_CONFERENCE = 'LOAD_CONFERENCE';
export const CONFERENCE_ERROR = 'CONFERENCE_ERROR';
export const ADD_CONFERENCE = 'ADD_CONFERENCE';
export const BOOK_CONFERENCE = 'BOOK_CONFERENCE';
export const CONFERENCE_BOOKINGS = 'CONFERENCE_BOOKINGS';
export const MY_CONFERENCE_BOOKINGS = 'MY_CONFERENCE_BOOKINGS';
export const DELETE_CONFERENCE_BOOKING = 'DELETE_CONFERENCE_BOOKING';
export const CANCEL_CONFERENCE_BOOKING = 'CANCEL_CONFERENCE_BOOKING';